import { post } from '@/lib/api';
import type { DemoKind, DemoState } from '@/types';

/**
 * Demo mode (apps/server routes/demo.ts), for the one demo account. `start`
 * seeds its demo team from the chosen profile, wiping the last one; anyone
 * else gets a 404.
 */
export interface StartDemoInput {
  kind: DemoKind;
  state: DemoState;
  /** The only address the demo may send mail to. */
  email?: string;
}

export interface StartDemoResult {
  teamId: string;
  kind: DemoKind;
  state: DemoState;
}

export function startDemo(input: StartDemoInput) {
  return post<StartDemoResult>('/api/demo/start', {
    kind: input.kind,
    state: input.state,
    ...(input.email ? { email: input.email } : {})
  });
}

/** Wipes the demo team and reseeds the same profile. */
export async function resetDemo() {
  await post<{ ok: true }>('/api/demo/reset', {});
}
